"use client"

import * as React from "react"
import { X } from "lucide-react"
import { cn } from "@/lib/utils"

interface ClearButtonProps {
  onClear: () => void
  className?: string
  label?: string
}

/**
 * Small "x" affordance overlaid on a select/combobox trigger to clear the current selection.
 * Uses onPointerDown so the clear fires before the trigger's own pointer handler opens the menu
 * (works for both mouse and touch/pen input).
 */
export const ClearButton = ({ onClear, className, label = "Clear selection" }: ClearButtonProps) => (
  <button
    type="button"
    aria-label={label}
    onPointerDown={(e) => {
      e.preventDefault()
      e.stopPropagation()
      onClear()
    }}
    className={cn(
      "absolute right-7 top-1/2 -translate-y-1/2 flex h-5 w-5 items-center justify-center rounded-sm text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring",
      className
    )}
  >
    <X className="h-3.5 w-3.5" />
  </button>
)
